import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/analytics/ekonomika")({
  beforeLoad: requirePermissionGuard("hca.faktury.read"),
});
